import { Modal, Flex } from '@sequencehq/core-components'
import { GreyGrey0 } from '@sequencehq/core-components'
import { ServerAsset } from '@sequencehq/api'
import { AttachmentPdfPreview } from 'Assets/Attachments/AttachmentPdfPreview'

export const AttachmentPdfPreviewDrawer = ({
  id,
  url,
  fileName
}: ServerAsset) => (
  <Flex
    background={GreyGrey0}
    width="505px"
    height="100%"
    flexDirection="column"
  >
    <Modal.Header withBorder minHeight="49px">
      Preview
    </Modal.Header>
    <AttachmentPdfPreview
      url={url}
      fileName={fileName}
      data-testid={`pdf-preview.drawer.${id}`}
    />
  </Flex>
)
